import React from 'react';
import { BodyText, HeadingText } from '@swift-paypal/pp-react';

export const StandardDetails = () => (
  <>
    <HeadingText size="sm" className="forgiveness-heading-text">
      Upload supporting documents to finish applying
    </HeadingText>
    <BodyText as="p">
      Document requirements will vary based on your loan forgiveness application.
      To see what&apos;s required for your application, click
      Get Started for each category and provide the requested information.
    </BodyText>
  </>
);
